// store/slices/orderSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { constants } from '../../constants';

const orderSlice = createSlice({
  name: 'order',
  initialState: {
    order_details: [],
    customername: '',
    customeremail: '',
    customerphonenumber: '',
    vanid: '',
    discountamount:0,
    paymentmode:constants.PAYMENT_MODE.CASH,
    paymentstatus:constants.PAYMENT_STATUS.PENDING,
    coupon_code:'',
    coupon_validation_status:0,
    coupon_discount_amount:0
  },
  reducers: {
    addProductToOrder: (state, action) => {
      const product = action.payload;
    
      const existing = state.order_details.find(item => item.id === product.id);
    
      if (!existing) {
        state.order_details.push({
          ...product,
        orderQty: 1,
          unitprice: product.price
        });
      } else {
        // already exists → increment quantity
        existing.orderQty = (existing.orderQty || 1) + 1;
      }
    },
    updateProductInOrder: (state, action) => {
      const { id, field, value } = action.payload;
      const product = state.order_details.find(p => p.id === id);
      if (!product) return;

      product[field] = value;

    },
    removeOrderItem: (state, action) => {
      state.order_details = state.order_details.filter(p => p.id !== action.payload);
    },
    updateCustomerField: (state, action) => {
      const { field, value } = action.payload;
      state[field] = value;
    },
    updateOrderdata: (state, action) => {
      const { field, value } = action.payload;
      state[field] = value;
    },
    resetOrder: () => ({
      order_details: [],
      customername: '',
      customeremail: '',
      customerphonenumber: '',
    }),
  },
});

export const {
  addProductToOrder,
  updateProductInOrder,
  removeOrderItem,
  updateCustomerField,
  resetOrder,
  updateOrderdata
} = orderSlice.actions;

export default orderSlice.reducer;
